export const environment = {
  production: true,
  googleMapsApiKey: 'AIzaSyBWHGIO1ESG6eq_ZTY6wzhAR8ry-FrwdJY',
  tinyMCEApiKey: 'k9jry19d7bh0uu2hgvy5widnnacv77xpt768ywhb92g6g6a9',
  backendUrl: 'https://admin-api.popvalet.com/',
  stripeKey: 'pk_live_2m2I2sy1j7vcLRI3XBxyJ9ul',
  versionCheckUrl: 'https://admin.popvalet.com/version.txt'
};
